<template>
	<v-toolbar flat height="50" :class="{'panel-toolbar': panel}">
		<template v-if="panel" #prepend>
			<v-select
				:model-value="selectedPanel"
				:items="availablePanels"
				variant="outlined"
				density="compact"
				hide-selected
				hide-details
				style="width: 150px"
				@update:model-value="changePanel">
				<template #selection="{ item }">
					<v-toolbar-title>
						{{ item.title }}
					</v-toolbar-title>
				</template>
			</v-select>
		</template>

		<template #default>
			<ToolbarItems :items="items"/>
		</template>

		<template v-if="panel && !liveMode" #append>
			<div style="min-width: 220px">
				<StationSelector :panel="panel"/>
			</div>
		</template>
	</v-toolbar>
</template>

<script>
/* Modules */
import StationSelector from "@/components/StationSelector.vue";
import ToolbarItems from "@/components/ToolbarItems.vue";

/*Enums*/
import Panels from "@/enums/Panels";

/* Libraries */
import emitter from "@/emitter";

/* Mixins */
import SequencerPlayerStudioStatus from "@/mixins/SequencerPlayerStudioStatus";

export default {
	name: "Toolbar",

	components: {StationSelector, ToolbarItems},

	mixins: [SequencerPlayerStudioStatus],

	props: {
		panelParams: {
			type: Object,
			default: () => ({})
		},
		items: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			selectedPanel: null
		}
	},

	computed: {
		panel() {
			return this.panelParams?.api?.panel;
		},

		liveMode() {
			return this.$store.getters.liveMode();
		},

		availablePanels() {
			return Panels.getArray({
				liveMode: this.liveMode,
				userIsHost: this.userIsHost,
				stationID: this.liveMode ?
				           this.$store.getters.liveModeSelectedStationID() :
				           this.panelParams.params.selectedStationID
			})
		}
	},

	mounted() {
		if (this.panelParams?.params) {
			this.selectedPanel = this.panelParams.params.panelName;
		}
	},

	methods: {
		changePanel(panel) {
			emitter.emit("docking:replacePanel", {oldPanel: this.panel, panel});
		}
	}
}
</script>

<style lang="scss" scoped>
:deep(.v-toolbar__prepend) {
	margin-inline: 0 12px;
}

:deep(.v-toolbar__append) {
	margin-inline: auto 0;
}
</style>